@if (formData) {
  <h5
    class="mobi-ui-card-fullwidth mobi-ui-font-h6 mobi-ui-text-has-border mobi-ui-padding-t-md"
  >
    {{
      'calc_selection'
        | texts
          : {
              context: 'primcalc',
              default: 'Leistungswahl',
            }
    }}
  </h5>
  <ul class="mobi-ui-list-silent is-block mobi-ui-font-size-50">
    <li>
      <div class="py-[4px]">
        {{
          'uvg_benefit_1'
            | texts
              : {
                  context: 'primcalc',
                  default:
                    'Deckung aller Berufsunfälle während der Arbeit und auf dem direkten Arbeitsweg',
                }
        }}
        <mobi-ui-icon-major name="tik_checkbox" />
      </div>
    </li>
    <li>
      <div class="py-[4px]">
        {{
          'uvg_benefit_2'
            | texts
              : {
                  context: 'primcalc',
                  default:
                    'Pflegeleistungen und Kostenvergütungen: Rettungstransporte, ambulante Behandlungen, Spital- und Kuraufenthalte',
                }
        }}
        <mobi-ui-icon-major name="tik_checkbox" />
      </div>
    </li>
    <li>
      <div class="py-[4px]">
        {{
          'uvg_benefit_3'
            | texts
              : {
                  context: 'primcalc',
                  default:
                    'Taggelder, Invalidenrente, Integritätsentschädigung, Hilflosenentschädigung und Hinterlassenenrente',
                }
        }}
        <mobi-ui-icon-major name="tik_checkbox" />
      </div>
    </li>
  </ul>
  <dl
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border mobi-ui-font-size-50"
  >
    <dt class="mobi-ui-font-h6">
      {{
        'uvg_sum_ins_total' | texts: { context: 'primcalc', default: 'Lohnsumme Total' }
      }}
    </dt>
    <dd>CHF&nbsp;{{ formatNumber(result.sum_insured_professional, '0,0.00') }}</dd>
  </dl>
  <dl
    class="mobi-ui-card-fullwidth mobi-ui-list-silent is-description-list mobi-ui-margin-t-md mobi-ui-text-has-border mobi-ui-font-size-50"
  >
    <dt class="mobi-ui-font-h6">
      {{
        'contract_duration' | texts: { context: 'primcalc', default: 'Vertragslaufzeit' }
      }}
    </dt>
    <dd>
      @if (formData[formId + '--ins_start'] === 'tomorrow') {
        <span> {{ tomorrow }}&nbsp;-&nbsp;{{ contractEnd }} </span>
      } @else {
        {{ contractStart }}&nbsp;-&nbsp;{{ contractEnd }}
      }
    </dd>
  </dl>
  <div class="mobi-ui-text-center mobi-ui-margin-t-lg">
    <div class="mobi-ui-price-major is-center">
      <span class="mobi-ui-price-unit-major">CHF</span>
      <span class="mobi-ui-price-value-major premium-value">{{
        formatNumber(result.annual_premium_professional, '0,0.00')
      }}</span>
    </div>
    <span class="">
      {{ 'annual_premium' | texts: { context: 'primcalc', default: 'Jahresprämie' } }}
    </span>
  </div>
}
